import React from 'react'
import {  BannerImageCard } from '@mindlab-org/component-library/dist/index.js'

export default function BannerImageCardHandler (props) {
  return < BannerImageCard {...props} />
}
